import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Tooltip from '../Tooltip'
import Icon from '../Icon'
import { moment } from '../../utils/dates'

class CustomField extends Component {
  state = {
    isClean: true,
  }

  onBlur() {
    if (!this.state.isClean) {
      return
    }
    this.setState({ isClean: false })
  }

  render() {
    const {
      classes,
      inputClassName,
      placeholder,
      pattern,
      min,
      max,
      icon,
      value,
      onFocus,
      onChange,
      onKeyDown,
      inlineError,
      isRequired,
      errorMessage,
      invalid,
      isDisabled,
      onBlur,
      type,
      name,
      dirty,
      plain,
      browserAutocomplete,
      label,
      labelClassName,
      reference,
    } = this.props
    const isInvalid =
      invalid ||
      (isRequired && !value && !this.state.isClean) ||
      (isRequired && !value && errorMessage) ||
      (min ? type === 'date' && moment(value) < moment(min) : false) ||
      (type === 'date' && moment(value) < moment().subtract(1, 'days')) ||
      (max ? type === 'date' && moment(value) > moment(max) : false) ||
      (value && errorMessage && Boolean(errorMessage.length))

    return (
      <div className={classes.wrapper}>
        <label className={labelClassName}>
          {label && <span className={classes.label}>{label}</span>}
          <input
            ref={reference}
            type={type}
            name={name}
            placeholder={placeholder}
            pattern={pattern}
            min={min}
            max={max}
            onBlur={x => (onBlur ? onBlur(x) : this.onBlur(x))}
            onFocus={onFocus}
            className={classNames(classes.input, inputClassName, {
              [classes.inputStyled]: !plain,
              [classes.isEditedInput]: dirty,
              [classes.isInvalidInput]: isInvalid,
              [classes.hasValue]: value,
              [classes.requiredFieldBorder]: isInvalid,
              [classes.disabled]: !plain && isDisabled,
            })}
            onChange={e => onChange && onChange(e.target.value)}
            onKeyDown={onKeyDown}
            value={value}
            disabled={isDisabled}
            required={isRequired}
            autoComplete={browserAutocomplete}
          />
          {icon && (
            <Icon
              name={icon}
              className={classNames(classes.icon, {
                [classes.isInvalidIcon]: invalid || isInvalid,
              })}
            />
          )}
        </label>
        {errorMessage &&
          inlineError && (
            <Tooltip inlineError={inlineError} errorMessage={errorMessage} />
          )}
      </div>
    )
  }
}

CustomField.propTypes = {
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  pattern: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  isRequired: PropTypes.bool,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
  dirty: PropTypes.bool,
  plain: PropTypes.bool,
  browserAutocomplete: PropTypes.string,
  inlineError: PropTypes.bool,
  submitFailed: PropTypes.bool,
  touched: PropTypes.bool,
  invalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  name: PropTypes.string,
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    input: PropTypes.string,
    icon: PropTypes.string,
    hasValue: PropTypes.string,
    inputStyled: PropTypes.string,
    isEditedInput: PropTypes.string,
    requiredFieldBorder: PropTypes.string,
    isInvalidInput: PropTypes.string,
    isInvalidIcon: PropTypes.string,
    disabled: PropTypes.string,
  }),
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  reference: PropTypes.object,
}

CustomField.defaultProps = {
  type: 'text',
  dirty: false,
  plain: true,
}

export default CustomField
